export default __webpack_public_path__ + "static/media/1653330140358 (1) (1).840228b4.jpg";